import React, { useCallback } from 'react';
import AdminCrudListPage from '../../../components/admin/AdminCrudListPage';
import KkpColorBadge from '../../../components/kkp/KkpColorBadge';
import { AppBadge } from '../../../components/ui';
import secteursAdminService from '../../../services/secteursAdminService';
import { ROUTES } from '../../../config/routes';

const COLUMNS = [
  {
    key: 'nomSecteur',
    label: 'Nom du secteur',
    render: (row) => <strong>{row.nomSecteur}</strong>,
  },
  {
    key: 'nomCommercial',
    label: 'Nom commercial',
  },
  {
    key: 'couleur',
    label: 'Couleur',
    getValue: (row) => row.couleurSecteur,
    render: (row) => (
      <KkpColorBadge color={row.couleurSecteur} vivid>
        {row.couleurSecteur}
      </KkpColorBadge>
    ),
  },
  {
    key: 'zones',
    label: 'Zones',
    sortType: 'number',
    getValue: (row) => row.zoneCount ?? 0,
    render: (row) => <AppBadge variant="info">{row.zoneCount ?? 0} zones</AppBadge>,
  },
];

const SecteursAdminSecteursPage = () => {
  const load = useCallback(async (page, q, { limit } = {}) => {
    const result = await secteursAdminService.listSecteurs({ search: q, page, limit: limit ?? 20 });
    return { rows: result.secteurs, pagination: result.pagination };
  }, []);

  return (
    <AdminCrudListPage
      title="Gestion des secteurs"
      subtitle="Groupes commerciaux de zones"
      backTo={ROUTES.secteurs.admin}
      newTo={ROUTES.secteurs.adminSecteurNew}
      newLabel="Nouveau secteur"
      search={{
        id: 'admin-secteurs-search',
        placeholder: 'Nom de secteur ou commercial…',
      }}
      columns={COLUMNS}
      load={load}
      emptyMessage="Aucun secteur trouvé"
      editTo={(row) => ROUTES.secteurs.adminSecteurEdit(row.id)}
      onDelete={(row) => secteursAdminService.deleteSecteur(row.id)}
      deleteConfirm={{
        title: 'Supprimer ce secteur ?',
        message: 'Le secteur sera retiré de l’administration.',
        successMessage: 'Secteur supprimé',
      }}
    />
  );
};

export default SecteursAdminSecteursPage;
